import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { InputBaseParams } from "../Form";
import RichTextEditor from "./RichTextEditor";

const RichTextArea = ({
  name,
  rules,
  placeholder,
  readOnly = false,
  saveAsMarkdown = false,
  minHeight,
  maxHeight
}: InputBaseParams & {
  placeholder?: string;
  readOnly?: boolean;
  saveAsMarkdown?: boolean;
  minHeight?: string;
  maxHeight?: string;
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { value, onChange, onBlur },
        fieldState: { error }
      }) => (
        <div className="w-full">
          <RichTextEditor
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={readOnly}
            minHeight={minHeight}
            maxHeight={maxHeight}
            outputFormat={saveAsMarkdown ? 'markdown' : 'html'}
            className={error ? "border-red-500 ring-red-100" : ""}
          />
          {error && (
            <p className="mt-1 text-sm text-red-500">
              {error.message || "This field is required"}
            </p>
          )}
        </div>
      )}
    />
  );
};

export default RichTextArea;
